/*
 * @Author: your name
 * @Date: 2021-04-21 14:28:27
 * @LastEditTime: 2021-09-07 14:33:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud_app\src\api\httpget.js
 */
import axios from "./axios";

let service = axios();
// get 请求
export default function httpGet({ url, params = {}, config = {} }) {
  return new Promise((resolve, reject) => {
    service
      .get(url, {
        params,
        ...config
      })
      .then(res => {
        resolve(res?.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
